/**
 * Placeholder shown to non-admin members while the tenant is in
 * setup_review. The tenant-admin is the only role that can edit; members
 * are parked here until the admin activates.
 *
 * Phase 44.3.
 */

import Header from "../../components/Header.jsx";

export default function SetupPendingPlaceholder() {
  return (
    <>
      <Header />
      <main className="setup-pending">
        <div className="container setup-pending__card">
          <h1>Workspace setup in progress</h1>
          <p>
            Your administrator is still configuring this workspace. You&apos;ll
            be able to create projects and run research pipelines once
            they&apos;ve completed setup.
          </p>
          <p className="setup-pending__muted">
            Try refreshing this page or checking back in a few minutes. If
            this persists for more than 24 hours, please contact your
            administrator.
          </p>
        </div>
      </main>
    </>
  );
}
